import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatNumber } from '@vortx/shared-ui';

export default function ResiliencePanel({ data }) {
  if (!data) return null;
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1">Resilience</Typography>
      {data.outage_duration_hours != null && (
        <Typography>
          Outage Duration: <b>{formatNumber(data.outage_duration_hours, 0)}</b> hrs
        </Typography>
      )}
      {data.percent_load_served != null && (
        <Typography>
          % Load Served: <b>{formatNumber(data.percent_load_served, 1)}</b>
        </Typography>
      )}
    </Box>
  );
}
